"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4871],{

/***/ 93559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30132);
/* harmony import */ var svgIcons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53893);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding: 22px 20px 0;\n      height: 50px;\n      align-items: flex-start;\n      .sh-title {\n        font-size: 12px;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  font-weight: 500;\n  .sh-title {\n    font-size: 16px;\n    color: #999999;\n  }\n  .sh-more-btn {\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n    gap: 3px;\n    color: #999999;\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var SearchResultHeader = function(param) {
    var _showMoreBtn = param.showMoreBtn, showMoreBtn = _showMoreBtn === void 0 ? false : _showMoreBtn, href = param.href, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "sh-title",
                children: children
            }),
            showMoreBtn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: href !== undefined ? href : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                    className: "sh-more-btn",
                    children: [
                        "더보기",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons__WEBPACK_IMPORTED_MODULE_4__/* .ArrowRight */ .ol, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SearchResultHeader);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SearchResultHeader__StyledWrapper",
    componentId: "sc-6abad148-0"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject());
});


/***/ }),

/***/ 13358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var svgIcons_ExpandMore__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40934);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: inline-block;\n  background-color: white;\n  select {\n    border: none;\n    background-color: transparent;\n    -o-appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    outline: none;\n    padding: 10px 25px 10px 15px;\n    cursor: pointer;\n  }\n\n  border: 1px solid #e8e8e8;\n  border-radius: 5px;\n  font-size: 14px;\n  .icon-arrow {\n    top: 8px;\n    bottom: 0;\n    right: 5px;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 20px;\n    height: 20px;\n    svg {\n      width: 10px;\n      height: 10px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Select = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("select", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: "sort-select"
            }, props), {
                children: children
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "icon-arrow",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(svgIcons_ExpandMore__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "Select__StyledWrapper",
    componentId: "sc-1824363b-0"
})(_templateObject());


/***/ }),

/***/ 67220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44119);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(graphql_tag__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30132);
/* harmony import */ var generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47079);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query gqlEmptyCard($type: RecommendSearchKeywordType) {\n    recommendSearchKeywordList(type: $type) {\n      recommendSearchKeywords {\n        id\n        title\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: white;\n  border: 1px solid #e8e8e8;\n  padding: 72px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  .empty-title {\n    font-size: 20px;\n    margin-bottom: 20px;\n    font-weight: 500;\n    span {\n      color: #01a0ff;\n    }\n  }\n  .empty-subtitle {\n    font-size: 16px;\n    color: #999;\n    margin-bottom: 64px;\n  }\n  .recommend-search-keyword {\n    .recommend-search-keyword-header {\n      font-size: 16px;\n      margin-bottom: 12px;\n    }\n    .recommend-search-keyword-list {\n      display: flex;\n      flex-wrap: wrap;\n      gap: 10px;\n      width: 340px;\n      justify-content: center;\n      a {\n        color: #01a0ff;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







graphql_tag__WEBPACK_IMPORTED_MODULE_3___default()(_templateObject());
var EmptyCard = function() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var query = "".concat(router.query.q || "");
    var data = (0,generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useGqlEmptyCardQuery */ .RsL)({
        variables: {
            type: generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .RecommendSearchKeywordType.RECOMMEND_CHANNEL */ .HDE.RECOMMEND_CHANNEL
        }
    }).data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "empty-title",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: query
                    }),
                    " 검색 결과가 없습니다."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "empty-subtitle",
                children: [
                    "단어의 철자가 정확한지 확인하세요. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "다른 검색어를 사용해보세요. ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "더 일반적인 검색어를 사용해보세요."
                ]
            }),
            data && ((ref = data.recommendSearchKeywordList) === null || ref === void 0 ? void 0 : ref.recommendSearchKeywords) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "recommend-search-keyword",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "recommend-search-keyword-header",
                        children: "이런 검색어는 어떠세요?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "recommend-search-keyword-list",
                        children: data.recommendSearchKeywordList.recommendSearchKeywords.map(function(keyword) {
                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: "/channel/search?q=".concat(keyword === null || keyword === void 0 ? void 0 : keyword.title),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                    children: [
                                        "#",
                                        keyword === null || keyword === void 0 ? void 0 : keyword.title
                                    ]
                                })
                            }, keyword === null || keyword === void 0 ? void 0 : keyword.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyCard);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "EmptyCard__StyledWrapper",
    componentId: "sc-be7301b9-0"
})(_templateObject1());


/***/ }),

/***/ 34871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ screen_ScreenChannelSearch; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsMobile.tsx
var useIsMobile = __webpack_require__(50516);
// EXTERNAL MODULE: ./src/app.styled/media.ts
var media = __webpack_require__(68250);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.components/tabs/LineTabs/LineTabs.tsx
var LineTabs = __webpack_require__(28912);
// EXTERNAL MODULE: ./src/app.feature/channel/component/ChannelAdBannerBox.tsx
var ChannelAdBannerBox = __webpack_require__(12104);
// EXTERNAL MODULE: ./src/app.feature/channel/component/ChannelFooter.tsx
var ChannelFooter = __webpack_require__(47036);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/svgIcons/index.ts + 9 modules
var svgIcons = __webpack_require__(53893);
// EXTERNAL MODULE: ./src/generated/graphql.ts
var graphql = __webpack_require__(47079);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/components/LoginAlert.tsx
var LoginAlert = __webpack_require__(39749);
// EXTERNAL MODULE: ./src/app.feature/channel/component/ChannelSearchbar.tsx
var ChannelSearchbar = __webpack_require__(63319);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/ChannelNavbar/ChannelNavbar.desktop.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff;\n  border-bottom: 1px solid #e8e8e8;\n  transition: box-shadow 0.3s ease-in-out;\n  &.sticky {\n    position: sticky;\n    top: 61px;\n  }\n  .nav-content {\n    width: 100%;\n    max-width: 1148px;\n    height: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin: 0 auto;\n    padding: 0 24px 0 14px;\n    .lt {\n      display: flex;\n      .tab {\n        :hover {\n          color: #01a0ff;\n        }\n      }\n      .tab-my-channel {\n        font-size: 16px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        white-space: nowrap;\n        gap: 2px;\n        padding-left: 5px;\n        font-weight: 500;\n        .arrow-right {\n          font-size: 13px;\n          padding-top: 1px;\n        }\n      }\n    }\n    .search-bar-wrapper {\n      opacity: 0;\n      padding: 8px 0;\n      width: 100%;\n      max-width: 780px;\n      transform: translate(0px, -60px);\n      transition: transform 0.3s ease, opacity 0.3s ease, max-width 0.3s ease;\n      &.visible {\n        opacity: 1;\n        max-width: 780px;\n        transform: translate(0px, 0px);\n      }\n      .search-bar {\n        height: 40px;\n        &:focus-within {\n          border: 1px solid #01a0ff;\n        }\n      }\n    }\n  }\n  ",
        " {\n    background-color: #fafafa;\n    &.sticky {\n      top: 0;\n    }\n    .nav-content {\n      gap: 0;\n      padding: 0 20px;\n      height: 50px;\n      .lt {\n        .tab {\n          font-size: 15px;\n          margin-left: -13px;\n        }\n        .tab-my-channel {\n          font-size: 15px;\n          gap: 0;\n          padding: 0;\n          margin-left: -4px;\n          .arrow-right {\n            font-size: 12px;\n          }\n        }\n      }\n      .search-bar-mobile {\n        display: flex;\n        align-items: center;\n        .search-modal-btn {\n          font-size: 13px;\n          align-items: center;\n          display: flex;\n          flex-shrink: 0;\n          cursor: pointer;\n\n          &.tag-btn {\n            &[data-active='true'] {\n              color: #01a0ff;\n              svg {\n                path {\n                  fill: #01a0ff;\n                }\n              }\n            }\n          }\n        }\n        .follow-divider {\n          height: 10px;\n          width: 1px;\n          background-color: #e8e8e8;\n          margin: 0 7px;\n        }\n        .search-btn {\n          cursor: pointer;\n          svg {\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
















var ChannelNavbarDesktop = function(param) {
    var _sticky = param.sticky, sticky = _sticky === void 0 ? false : _sticky, _searchBar = param.searchBar, searchBar = _searchBar === void 0 ? false : _searchBar, initialTab = param.initialTab, className = param.className;
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(false), loginModalOpened = ref2[0], setLoginModalOpened = ref2[1];
    var currentUserQuery = (0,graphql/* useCurrentUserQuery */.rkO)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var tabs = [
        {
            id: 0,
            name: "채널홈",
            size: "60px",
            href: {
                pathname: (0,util/* getWebviewHref */.ys)("/channel", isWebview),
                query: {
                    tab: "home"
                }
            }
        },
        {
            id: 1,
            name: "내 관심 소식",
            size: "103px",
            href: {
                pathname: (0,util/* getWebviewHref */.ys)("/channel", isWebview),
                query: {
                    tab: "interest"
                }
            }
        }, 
    ];
    var visibleSearchBar = (0,react.useMemo)(function() {
        if (searchBar === "visible") return true;
        if (searchBar === "unvisible") return false;
        return searchBar && sticky;
    }, [
        searchBar,
        sticky
    ]);
    var tabActive = router.pathname === "/channel" || router.pathname === "/webview/channel";
    var checkTab = function(menu) {
        var ref;
        if (menu.id === 1 && !((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : ref.currentUser)) {
            setLoginModalOpened(true);
            return false;
        }
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        className: (0,clsx_m/* default */.Z)(className, {
            sticky: sticky
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "nav-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lt",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LineTabs/* default */.Z, {
                                className: "line-tab",
                                data: tabs,
                                initialTab: initialTab ? tabs[initialTab] : undefined,
                                active: tabActive,
                                disableGlider: isMobile,
                                checkTab: checkTab
                            }),
                            ((ref = currentUserQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.currentUser) === null || ref1 === void 0 ? void 0 : ref1.channel) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: (0,util/* getWebviewHref */.ys)("/channel/".concat(currentUserQuery.data.currentUser.channel.url), isWebview),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "tab-my-channel",
                                    children: [
                                        "내 채널 바로가기",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {
                                            className: "arrow-right"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "search-bar-wrapper desktop ".concat(visibleSearchBar ? "visible" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchbar/* default */.Z, {
                            className: "search-bar"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoginAlert/* default */.Z, {
                DialogProps: {
                    open: loginModalOpened
                },
                onRequestClose: function() {
                    return setLoginModalOpened(false);
                }
            })
        ]
    });
};
/* harmony default export */ var ChannelNavbar_desktop = (ChannelNavbarDesktop);
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelNavbar.desktop__StyledWrapper",
    componentId: "sc-877ab2e5-0"
})(_templateObject(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./src/app.components/SearchResultHeader.tsx
var SearchResultHeader = __webpack_require__(93559);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/component/EmptyCard.tsx
var EmptyCard = __webpack_require__(67220);
// EXTERNAL MODULE: ./src/app.feature/channel/component/cards/ChannelCard/ChannelCard.tsx
var ChannelCard = __webpack_require__(87645);
// EXTERNAL MODULE: ./src/app.feature/channel/component/cards/ChannelCard/ChannelCardLoading.tsx
var ChannelCardLoading = __webpack_require__(27662);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/lists/ChannelList.tsx

function ChannelList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment ChannelCardList_ChannelEdge on ChannelEdge {\n    cursor\n    node {\n      ...channelCard_channel\n    }\n  }\n"
    ]);
    ChannelList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .channel-card-wrapper {\n    border-radius: 5px;\n    background-color: white;\n    padding: 8px 28px;\n    border: 1px solid #e8e8e8;\n  }\n  .hr {\n    height: 1px;\n    background-color: #f4f4f4;\n  }\n  ",
        " {\n    .hr {\n      height: 1px;\n      background-color: #f4f4f4;\n    }\n    .channel-card-wrapper {\n      border: none;\n      padding: 0px 20px;\n      .channel-card {\n        padding: 17px 0;\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








src_default()(ChannelList_templateObject());
var ChannelList = function(param) {
    var loading = param.loading, data = param.data, _skeletonSize = param.skeletonSize, skeletonSize = _skeletonSize === void 0 ? 3 : _skeletonSize, className = param.className;
    var skeletonArr = new Array(skeletonSize).fill("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelList_StyledWrapper, {
        className: className,
        children: [
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "channel-card-wrapper",
                children: skeletonArr.map(function(_, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelCardLoading/* default */.Z, {
                                type: "search"
                            }),
                            idx !== 4 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hr"
                            })
                        ]
                    }, idx);
                })
            }),
            data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "channel-card-wrapper",
                children: data.map(function(edge, idx) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelCard/* default */.Z, {
                                className: "channel-card",
                                type: "SEARCH",
                                data: edge.node
                            }),
                            (data.length || 0) - 1 !== idx && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hr"
                            })
                        ]
                    }, edge.cursor);
                })
            }),
            !loading && data.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCard/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var lists_ChannelList = (ChannelList);
var ChannelList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelList__StyledWrapper",
    componentId: "sc-e3972613-0"
})(_templateObject1(), media/* mobileBreakPoint */.vm);

// EXTERNAL MODULE: ./src/app.feature/channel/component/lists/NewsList.tsx + 1 modules
var NewsList = __webpack_require__(41817);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchAll/ChannelSearchAll.tsx



function ChannelSearchAll_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlChannelSearchAllTab(\n    $newsItemFilterBy: NewsItemFeedFilter\n    $newsItemFeedOrderBy: NewsItemOrder\n    $newsItemFeedFirst: Int\n    $newsItemFeedafter: String\n    $channelFeedFilterBy: ChannelFilter\n    $channelFeedOrderBy: ChannelOrder\n    $channelFeedfirst: Int\n  ) {\n    newsItemFeed(\n      filterBy: $newsItemFilterBy\n      orderBy: $newsItemFeedOrderBy\n      first: $newsItemFeedFirst\n      after: $newsItemFeedafter\n    ) {\n      ...NewsItemFeedList_newsItemConnection\n    }\n    channelFeed(\n      filterBy: $channelFeedFilterBy\n      orderBy: $channelFeedOrderBy\n      first: $channelFeedfirst\n    ) {\n      ...FollowList_ChannelConnection\n    }\n  }\n"
    ]);
    ChannelSearchAll_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChannelSearchAll_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  .more-button {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    background-color: #e9ecf0;\n    cursor: pointer;\n    &.last {\n      margin-bottom: 40px;\n    }\n  }\n"
    ]);
    ChannelSearchAll_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










src_default()(ChannelSearchAll_templateObject());
var ChannelSearchAll = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var variables = {
        channelFeedFilterBy: {
            q: query
        },
        newsItemFilterBy: {
            q: query
        },
        newsItemFeedOrderBy: {
            direction: graphql/* OrderDirection.DESC */.N9t.DESC,
            field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
        },
        channelFeedfirst: 3,
        newsItemFeedFirst: 3
    };
    var ref3 = (0,graphql/* useGqlChannelSearchAllTabQuery */.RJl)({
        variables: (0,_object_spread/* default */.Z)({}, variables)
    }), data = ref3.data, loading = ref3.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchAll_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultHeader/* default */.Z, {
                children: [
                    "채널",
                    " ",
                    (data === null || data === void 0 ? void 0 : (ref = data.channelFeed) === null || ref === void 0 ? void 0 : ref.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.channelFeed.totalCount, "건") : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lists_ChannelList, {
                data: (data === null || data === void 0 ? void 0 : (ref1 = data.channelFeed) === null || ref1 === void 0 ? void 0 : ref1.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            ((data === null || data === void 0 ? void 0 : (ref2 = data.channelFeed) === null || ref2 === void 0 ? void 0 : ref2.totalCount) || 0) > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        tab: "channel"
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "more-button",
                    children: "채널 검색 결과 모두 보기"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultHeader/* default */.Z, {
                children: [
                    "소식",
                    " ",
                    (data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount, "건") : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList/* default */.Z, {
                data: (data === null || data === void 0 ? void 0 : data.newsItemFeed.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            ((data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) || 0) > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        tab: "news"
                    })
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "more-button last",
                    children: "소식 검색결과 모두 보기"
                })
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchAll_ChannelSearchAll = (ChannelSearchAll);
var ChannelSearchAll_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchAll__StyledWrapper",
    componentId: "sc-a6f6f8f1-0"
})(ChannelSearchAll_templateObject1());

// EXTERNAL MODULE: ./node_modules/immutability-helper/index.js
var immutability_helper = __webpack_require__(7145);
var immutability_helper_default = /*#__PURE__*/__webpack_require__.n(immutability_helper);
// EXTERNAL MODULE: ./src/app.components/inputs/Select.tsx
var Select = __webpack_require__(13358);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIntersect.tsx
var useIntersect = __webpack_require__(23913);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchChannel/ChannelSearchChannel.tsx

function ChannelSearchChannel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlChannelSearchChannelListTab(\n    $filterBy: ChannelFilter\n    $orderBy: ChannelOrder\n    $first: Int\n    $after: String\n  ) {\n    channelFeed(\n      filterBy: $filterBy\n      orderBy: $orderBy\n      first: $first\n      after: $after\n    ) {\n      ...FollowList_ChannelConnection\n    }\n  }\n"
    ]);
    ChannelSearchChannel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChannelSearchChannel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  .header-wrapper {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  .end-content {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    color: #999999;\n  }\n"
    ]);
    ChannelSearchChannel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(ChannelSearchChannel_templateObject());
var ChannelSearchChannel = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var ref3 = (0,react.useState)(graphql/* ChannelOrderField.FOLLOWER */.JBi.FOLLOWER), orderField = ref3[0], setOrderField = ref3[1];
    var ref4 = (0,graphql/* useGqlChannelSearchChannelListTabQuery */.V$f)({
        variables: {
            filterBy: {
                q: query
            },
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: orderField
            },
            first: 20
        },
        notifyOnNetworkStatusChange: true
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var hasNextPage = (0,react.useMemo)(function() {
        if (!data || !data.channelFeed) return null;
        return data.channelFeed.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react.useMemo)(function() {
        if (!data || !data.channelFeed) return null;
        return data.channelFeed.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            filterBy: {
                q: query
            },
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: orderField
            },
            first: 20,
            after: lastCursor
        };
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.channelFeed) return previousQueryResult;
                var result = immutability_helper_default()(previousQueryResult, {
                    channelFeed: {
                        edges: {
                            $push: fetchMoreResult.channelFeed.edges
                        },
                        pageInfo: {
                            $set: fetchMoreResult.channelFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var handleChange = function(e) {
        if (e.target.value === "last-news") {
            setOrderField(graphql/* ChannelOrderField.LAST_NEWS_ITEM_CREATED_AT */.JBi.LAST_NEWS_ITEM_CREATED_AT);
        } else {
            setOrderField(graphql/* ChannelOrderField.FOLLOWER */.JBi.FOLLOWER);
        }
    };
    var target = (0,useIntersect/* default */.Z)(handleIntersect, [
        lastCursor,
        loading,
        fetchMore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchChannel_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultHeader/* default */.Z, {
                        children: [
                            "채널",
                            " ",
                            (data === null || data === void 0 ? void 0 : (ref = data.channelFeed) === null || ref === void 0 ? void 0 : ref.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.channelFeed.totalCount, "건") : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "follower",
                                children: "팔로워순"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "last-news",
                                children: "최신순"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lists_ChannelList, {
                data: (data === null || data === void 0 ? void 0 : (ref1 = data.channelFeed) === null || ref1 === void 0 ? void 0 : ref1.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelCardLoading/* default */.Z, {
                type: "search"
            }),
            !loading && !hasNextPage && (data === null || data === void 0 ? void 0 : (ref2 = data.channelFeed) === null || ref2 === void 0 ? void 0 : ref2.edges.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "end-content",
                children: "모든 채널을 확인했습니다."
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchChannel_ChannelSearchChannel = (ChannelSearchChannel);
var ChannelSearchChannel_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchChannel__StyledWrapper",
    componentId: "sc-6a4bd461-0"
})(ChannelSearchChannel_templateObject1());

// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemFeedLoading.tsx
var ScreenNewsItemFeedLoading = __webpack_require__(24744);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchNews/ChannelSearchNewsList.tsx

function ChannelSearchNewsList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query gqlChannelSearchNewsListTab(\n    $filterBy: NewsItemFeedFilter\n    $orderBy: NewsItemOrder\n    $first: Int\n    $after: String\n  ) {\n    newsItemFeed(\n      filterBy: $filterBy\n      orderBy: $orderBy\n      first: $first\n      after: $after\n    ) {\n      ...NewsItemFeedList_newsItemConnection\n    }\n  }\n"
    ]);
    ChannelSearchNewsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ChannelSearchNewsList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f6f8;\n  gap: 10px;\n  .end-content {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    color: #999999;\n  }\n"
    ]);
    ChannelSearchNewsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}












src_default()(ChannelSearchNewsList_templateObject());
var ChannelSearchNewsList = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var variables = {
        filterBy: {
            q: query
        },
        first: 20,
        orderBy: {
            direction: graphql/* OrderDirection.DESC */.N9t.DESC,
            field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
        }
    };
    var ref1 = (0,graphql/* useGqlChannelSearchNewsListTabQuery */.BTB)({
        variables: variables,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var hasNextPage = (0,react.useMemo)(function() {
        if (!data || !data.newsItemFeed) return null;
        return data.newsItemFeed.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react.useMemo)(function() {
        if (!data) return null;
        return data.newsItemFeed.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        // validation
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            filterBy: {
                q: query
            },
            first: 20,
            after: lastCursor,
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
            }
        };
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.newsItemFeed) return previousQueryResult;
                var result = immutability_helper_default()(previousQueryResult, {
                    newsItemFeed: {
                        edges: {
                            $push: fetchMoreResult.newsItemFeed.edges
                        },
                        pageInfo: {
                            $set: fetchMoreResult.newsItemFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var target = (0,useIntersect/* default */.Z)(handleIntersect, [
        lastCursor,
        loading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchNewsList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultHeader/* default */.Z, {
                children: [
                    "소식",
                    " ",
                    (data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount, "건") : ""
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList/* default */.Z, {
                data: (data === null || data === void 0 ? void 0 : data.newsItemFeed.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemFeedLoading/* default */.Z, {}),
            !loading && !hasNextPage && (data === null || data === void 0 ? void 0 : (ref = data.newsItemFeed) === null || ref === void 0 ? void 0 : ref.edges.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "end-content",
                children: "모든 소식을 확인했습니다."
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchNews_ChannelSearchNewsList = (ChannelSearchNewsList);
var ChannelSearchNewsList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchNewsList__StyledWrapper",
    componentId: "sc-e51b1ebf-0"
})(ChannelSearchNewsList_templateObject1());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/ScreenChannelSearch.desktop.tsx

function ScreenChannelSearch_desktop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 100vh;\n  .nav-bar {\n    z-index: 4;\n  }\n  .channel-content {\n    max-width: 1148px;\n    margin: 0 auto;\n    padding: 0 24px;\n    width: 100%;\n  }\n  .hr {\n    border-bottom: 1px solid #eeeeee;\n  }\n  .channel-search-header {\n    background-color: white;\n    padding-top: 50px;\n    .csh-title {\n      font-size: 30px;\n      font-weight: 600;\n      padding-bottom: 10px;\n    }\n  }\n  .csh-tabs {\n    top: 108px;\n    position: sticky;\n    background-color: white;\n    z-index: 1;\n  }\n  .csh-tabs-content {\n    display: grid;\n    grid-template-columns: minmax(730px, 730px) minmax(320px, 320px);\n    height: 60px;\n    gap: 50px;\n  }\n  .channel-search-content {\n    display: grid;\n    grid-template-columns: minmax(730px, 730px) minmax(320px, 320px);\n    gap: 50px;\n    & > .lt {\n      margin-top: 22px;\n    }\n    & > .rt {\n      margin-top: 68px;\n      .footer-wrapper {\n        margin: 20px 35px;\n      }\n    }\n  }\n"
    ]);
    ScreenChannelSearch_desktop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var channelSearchTabs = [
    {
        id: 0,
        name: "전체",
        size: "33%",
        href: {
            query: {
                tab: "all"
            }
        }
    },
    {
        id: 1,
        name: "소식",
        size: "33%",
        href: {
            query: {
                tab: "news"
            }
        }
    },
    {
        id: 2,
        name: "채널",
        size: "33%",
        href: {
            query: {
                tab: "channel"
            }
        }
    }, 
];
var ScreenChannelSearchDesktop = function() {
    var router = (0,next_router.useRouter)();
    var selectedMenu = (0,react.useMemo)(function() {
        return "".concat(router.query.tab ? router.query.tab : "all");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenChannelSearch_desktop_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelNavbar_desktop, {
                className: "nav-bar",
                searchBar: "visible",
                sticky: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "channel-search-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "channel-content csh-title",
                        children: "채널 검색"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "csh-tabs",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "channel-content csh-tabs-content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LineTabs/* default */.Z, {
                        fullWidth: true,
                        savePrevQuery: true,
                        data: channelSearchTabs,
                        initialTab: channelSearchTabs[0]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "channel-content channel-search-content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lt",
                        children: [
                            selectedMenu === "all" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchAll_ChannelSearchAll, {}),
                            selectedMenu === "news" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchNews_ChannelSearchNewsList, {}),
                            selectedMenu === "channel" && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchChannel_ChannelSearchChannel, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "rt",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelAdBannerBox/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "footer-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelFooter/* default */.Z, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenChannelSearch_desktop = (ScreenChannelSearchDesktop);
var ScreenChannelSearch_desktop_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenChannelSearch.desktop__StyledWrapper",
    componentId: "sc-2b2668c5-0"
})(ScreenChannelSearch_desktop_templateObject());

// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/component/SearchMobileHeader.tsx
var SearchMobileHeader = __webpack_require__(48002);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/screen/HotKeywordBoxList.tsx
var HotKeywordBoxList = __webpack_require__(2858);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchAll/ChannelSearchAllMobile.tsx



function ChannelSearchAllMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .channel-card-list {\n    background-color: white;\n    .hr {\n      height: 1px;\n      background-color: #f4f4f4;\n    }\n  }\n"
    ]);
    ChannelSearchAllMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var ChannelSearchAllMobile = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var variables = {
        channelFeedFilterBy: {
            q: query
        },
        newsItemFilterBy: {
            q: query
        },
        newsItemFeedOrderBy: {
            direction: graphql/* OrderDirection.DESC */.N9t.DESC,
            field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
        },
        channelFeedfirst: 3,
        newsItemFeedFirst: 3
    };
    var ref3 = (0,graphql/* useGqlChannelSearchAllTabQuery */.RJl)({
        variables: variables
    }), data = ref3.data, loading = ref3.loading;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchAllMobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "채널",
                            " ",
                            (data === null || data === void 0 ? void 0 : (ref = data.channelFeed) === null || ref === void 0 ? void 0 : ref.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.channelFeed.totalCount, "건") : ""
                        ]
                    }),
                    !!(data === null || data === void 0 ? void 0 : (ref1 = data.channelFeed) === null || ref1 === void 0 ? void 0 : ref1.totalCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                tab: "channel"
                            })
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "more-btn",
                            children: [
                                "더보기",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lists_ChannelList, {
                data: (data === null || data === void 0 ? void 0 : (ref2 = data.channelFeed) === null || ref2 === void 0 ? void 0 : ref2.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "소식",
                            " ",
                            (data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount, "건") : ""
                        ]
                    }),
                    !!(data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: {
                            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                tab: "news"
                            })
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            className: "more-btn",
                            children: [
                                "더보기",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(svgIcons/* ArrowRight */.ol, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList/* default */.Z, {
                data: (data === null || data === void 0 ? void 0 : data.newsItemFeed.edges) || [],
                loading: loading,
                skeletonSize: 3
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchAll_ChannelSearchAllMobile = (ChannelSearchAllMobile);
var ChannelSearchAllMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchAllMobile__StyledWrapper",
    componentId: "sc-139c32b-0"
})(ChannelSearchAllMobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchChannel/ChannelSearchChannelMobile.tsx

function ChannelSearchChannelMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f5f6f8;\n  .filter-select {\n    border: none;\n    background-color: transparent;\n    select {\n      text-align: end;\n      font-size: 12px;\n    }\n  }\n  .channel-card-list {\n    background-color: white;\n  }\n  .end-content {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    color: #999999;\n  }\n"
    ]);
    ChannelSearchChannelMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ChannelSearchChannelMobile = function() {
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var ref3 = (0,react.useState)(graphql/* ChannelOrderField.FOLLOWER */.JBi.FOLLOWER), orderField = ref3[0], setOrderField = ref3[1];
    var ref4 = (0,graphql/* useGqlChannelSearchChannelListTabQuery */.V$f)({
        variables: {
            filterBy: {
                q: query
            },
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: orderField
            },
            first: 20
        },
        notifyOnNetworkStatusChange: true
    }), data = ref4.data, loading = ref4.loading, fetchMore = ref4.fetchMore;
    var hasNextPage = (0,react.useMemo)(function() {
        if (!data || !data.channelFeed) return null;
        return data.channelFeed.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react.useMemo)(function() {
        if (!data || !data.channelFeed) return null;
        return data.channelFeed.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        // validation
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            filterBy: {
                q: query
            },
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: orderField
            },
            first: 20,
            after: lastCursor
        };
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.channelFeed) return previousQueryResult;
                var result = immutability_helper_default()(previousQueryResult, {
                    channelFeed: {
                        edges: {
                            $push: fetchMoreResult.channelFeed.edges
                        },
                        pageInfo: {
                            $set: fetchMoreResult.channelFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var handleChange = function(e) {
        if (e.target.value === "last-news") {
            setOrderField(graphql/* ChannelOrderField.LAST_NEWS_ITEM_CREATED_AT */.JBi.LAST_NEWS_ITEM_CREATED_AT);
        } else {
            setOrderField(graphql/* ChannelOrderField.FOLLOWER */.JBi.FOLLOWER);
        }
    };
    var target = (0,useIntersect/* default */.Z)(handleIntersect, [
        lastCursor,
        loading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchChannelMobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "content-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "채널",
                            " ",
                            (data === null || data === void 0 ? void 0 : (ref = data.channelFeed) === null || ref === void 0 ? void 0 : ref.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.channelFeed.totalCount, "건") : ""
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
                        className: "filter-select",
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "follower",
                                children: "팔로워순"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "last-news",
                                children: "최신순"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lists_ChannelList, {
                data: (data === null || data === void 0 ? void 0 : (ref1 = data.channelFeed) === null || ref1 === void 0 ? void 0 : ref1.edges) || [],
                loading: loading,
                skeletonSize: 1
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelCardLoading/* default */.Z, {
                type: "search"
            }),
            !loading && !hasNextPage && (data === null || data === void 0 ? void 0 : (ref2 = data.channelFeed) === null || ref2 === void 0 ? void 0 : ref2.edges.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "end-content",
                children: "모든 채널을 확인했습니다."
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchChannel_ChannelSearchChannelMobile = (ChannelSearchChannelMobile);
var ChannelSearchChannelMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchChannelMobile__StyledWrapper",
    componentId: "sc-f8239b10-0"
})(ChannelSearchChannelMobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/menus/ChannelSearchNews/ChannelSearchNewsListMobile.tsx

function ChannelSearchNewsListMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f5f6f8;\n  .end-content {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    color: #999999;\n  }\n"
    ]);
    ChannelSearchNewsListMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var ChannelSearchNewsListMobile = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var query = "".concat(router.query.q || "");
    var variables = {
        filterBy: {
            q: query
        },
        first: 20,
        orderBy: {
            direction: graphql/* OrderDirection.DESC */.N9t.DESC,
            field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
        }
    };
    var ref1 = (0,graphql/* useGqlChannelSearchNewsListTabQuery */.BTB)({
        variables: variables,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true
    }), data = ref1.data, loading = ref1.loading, fetchMore = ref1.fetchMore;
    var hasNextPage = (0,react.useMemo)(function() {
        if (!data || !data.newsItemFeed) return null;
        return data.newsItemFeed.pageInfo.hasNextPage;
    }, [
        data
    ]);
    var lastCursor = (0,react.useMemo)(function() {
        if (!data) return null;
        return data.newsItemFeed.pageInfo.endCursor;
    }, [
        data
    ]);
    var handleIntersect = function() {
        // validation
        if (!hasNextPage || !lastCursor || loading) return;
        var variables = {
            filterBy: {
                q: query
            },
            first: 20,
            after: lastCursor,
            orderBy: {
                direction: graphql/* OrderDirection.DESC */.N9t.DESC,
                field: graphql/* NewsItemOrderField.CREATED_AT */.bos.CREATED_AT
            }
        };
        fetchMore({
            variables: variables,
            updateQuery: function(previousQueryResult, param) {
                var fetchMoreResult = param.fetchMoreResult;
                if (!fetchMoreResult || !fetchMoreResult.newsItemFeed) return previousQueryResult;
                var result = immutability_helper_default()(previousQueryResult, {
                    newsItemFeed: {
                        edges: {
                            $push: fetchMoreResult.newsItemFeed.edges
                        },
                        pageInfo: {
                            $set: fetchMoreResult.newsItemFeed.pageInfo
                        }
                    }
                });
                return result;
            }
        });
    };
    var target = (0,useIntersect/* default */.Z)(handleIntersect, [
        lastCursor,
        loading,
        fetchMore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChannelSearchNewsListMobile_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content-header",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        "소식",
                        " ",
                        (data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount) ? "".concat(data === null || data === void 0 ? void 0 : data.newsItemFeed.totalCount, "건") : ""
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsList/* default */.Z, {
                data: (data === null || data === void 0 ? void 0 : data.newsItemFeed.edges) || [],
                loading: loading,
                skeletonSize: 3
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: target
            }),
            hasNextPage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemFeedLoading/* default */.Z, {}),
            !loading && !hasNextPage && (data === null || data === void 0 ? void 0 : (ref = data.newsItemFeed) === null || ref === void 0 ? void 0 : ref.edges.length) !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "end-content",
                children: "모든 소식을 확인했습니다."
            })
        ]
    });
};
/* harmony default export */ var ChannelSearchNews_ChannelSearchNewsListMobile = (ChannelSearchNewsListMobile);
var ChannelSearchNewsListMobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ChannelSearchNewsListMobile__StyledWrapper",
    componentId: "sc-f02c9eac-0"
})(ChannelSearchNewsListMobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/ScreenChannelSearch.mobile.tsx



function ScreenChannelSearch_mobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 100vh;\n  padding-top: 58px;\n  background-color: #fafafa;\n  .menu-list {\n    position: fixed;\n    width: 100%;\n    top: 108px;\n    z-index: 2;\n    height: 50px;\n    border-bottom: 1px solid #e8e8e8;\n    background-color: #fafafa;\n    display: flex;\n    align-items: stretch;\n    padding: 0 20px;\n    gap: 20px;\n    .menu {\n      cursor: pointer;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      font-size: 16px;\n      color: #999;\n      :hover {\n        background-color: transparent;\n      }\n      &[data-active='true'] {\n        color: #333;\n        font-weight: bold;\n      }\n    }\n  }\n  &[data-webview='true'] {\n    padding-top: 58px;\n    .menu-list {\n      top: 58px;\n    }\n  }\n  .content-header {\n    height: 50px;\n    padding: 20px 20px 13px;\n    font-size: 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    color: #999;\n    .more-btn {\n      color: #999;\n      display: flex;\n      align-items: center;\n      gap: 5px;\n      svg {\n        width: 12px;\n        height: 12px;\n      }\n    }\n  }\n  .channel-card-empty {\n    background-color: white;\n    height: 170px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    .empty-title {\n      font-size: 16px;\n      margin-bottom: 5px;\n      font-weight: 500;\n      span {\n        color: #01a0ff;\n      }\n    }\n    .empty-subtitle {\n      font-size: 12px;\n      color: #999;\n    }\n  }\n  .tab-content {\n    padding-top: 50px;\n  }\n"
    ]);
    ScreenChannelSearch_mobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}












var ScreenChannelSearchMobile = function() {
    var router = (0,next_router.useRouter)();
    var isWebview = (0,useIsWebview/* default */.Z)();
    var query = (0,react.useMemo)(function() {
        return "".concat(router.query.q || "");
    }, [
        router.query
    ]);
    var tabToMenu = {
        all: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchAll_ChannelSearchAllMobile, {}),
        news: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchNews_ChannelSearchNewsListMobile, {}),
        channel: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChannelSearchChannel_ChannelSearchChannelMobile, {})
    };
    var handleClose = function() {
        if (router.query.back) router.push("".concat(router.query.back));
        else router.push((0,util/* getWebviewHref */.ys)("/channel", isWebview));
    };
    var selectedTab = (0,react.useMemo)(function() {
        return "".concat(router.query.tab ? router.query.tab : "all");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenChannelSearch_mobile_StyledWrapper, {
        "data-webview": isWebview,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchMobileHeader/* default */.Z, {
                title: "채널 검색",
                onClose: handleClose
            }),
            query === "" && /*#__PURE__*/ (0,jsx_runtime.jsx)(HotKeywordBoxList/* default */.Z, {}),
            query !== "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "menu-list",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                        tab: "all"
                                    })
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "menu",
                                    "data-active": selectedTab === "all",
                                    children: "전체"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                        tab: "news"
                                    })
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "menu",
                                    "data-active": selectedTab === "news",
                                    children: "소식"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                                        tab: "channel"
                                    })
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: "menu",
                                    "data-active": selectedTab === "channel",
                                    children: "채널"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tab-content",
                        children: tabToMenu[selectedTab]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ScreenChannelSearch_mobile = (ScreenChannelSearchMobile);
var ScreenChannelSearch_mobile_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenChannelSearch.mobile__StyledWrapper",
    componentId: "sc-f08f3119-0"
})(ScreenChannelSearch_mobile_templateObject());

;// CONCATENATED MODULE: ./src/app.feature/channel/channel.search/screen/ScreenChannelSearch.tsx

function ScreenChannelSearch_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #f5f6f8;\n  .desktop {\n    display: block;\n  }\n  .mobile {\n    display: none;\n  }\n  ",
        " {\n    .desktop {\n      display: none;\n    }\n    .mobile {\n      display: block;\n    }\n  }\n"
    ]);
    ScreenChannelSearch_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var ScreenChannelSearch = function() {
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ScreenChannelSearch_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mobile",
                children: isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenChannelSearch_mobile, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "desktop",
                children: !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenChannelSearch_desktop, {})
            })
        ]
    });
};
/* harmony default export */ var screen_ScreenChannelSearch = (ScreenChannelSearch);
var ScreenChannelSearch_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenChannelSearch__StyledWrapper",
    componentId: "sc-6d480e59-0"
})(ScreenChannelSearch_templateObject(), media/* mobileBreakPoint */.vm);


/***/ }),

/***/ 12104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30132);
/* harmony import */ var app_constants_appInstallUrls__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69939);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  .ad-banner {\n    width: 100%;\n  }\n  .btn-list {\n    bottom: 5px;\n    left: 0;\n    right: 0;\n    position: absolute;\n    display: flex;\n    justify-content: center;\n    .play-store-btn {\n      position: relative;\n      width: 107px;\n      img {\n        width: 107px;\n        height: 43px;\n      }\n    }\n    .apple-store-btn {\n      position: relative;\n      width: 107px;\n      img {\n        width: 107px;\n        height: 43px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var ChannelAdBannerBox = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                className: "ad-banner",
                src: "/static/images/channel/ad_banner.jpg",
                alt: "ad-banner"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "btn-list",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: app_constants_appInstallUrls__WEBPACK_IMPORTED_MODULE_3__/* .PLAY_STORE_URL */ .s,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "play-store-btn",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            className: "play-store-img",
                            src: "/static/images/app-banner/play-store-badge.png",
                            alt: "구글플레이"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        href: app_constants_appInstallUrls__WEBPACK_IMPORTED_MODULE_3__/* .APP_STORE_URL */ .l,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "apple-store-btn",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                            className: "apple-store-img",
                            src: "/static/images/app-banner/apple-store-badge.png",
                            alt: "앱스토어"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ChannelAdBannerBox);
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ChannelAdBannerBox__StyledWrapper",
    componentId: "sc-bb9381dd-0"
})(_templateObject());


/***/ }),

/***/ 41817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ lists_NewsList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/graphql-tag/src/index.js
var src = __webpack_require__(44119);
var src_default = /*#__PURE__*/__webpack_require__.n(src);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(30132);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/context.ts + 1 modules
var context = __webpack_require__(52737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/app.feature/channel/hook/useReadNewsItemEffect.ts
var useReadNewsItemEffect = __webpack_require__(84108);
// EXTERNAL MODULE: ./src/app.modules/hooks/useIsWebview.tsx
var useIsWebview = __webpack_require__(67235);
// EXTERNAL MODULE: ./src/app.modules/util/index.tsx
var util = __webpack_require__(65677);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentForm/NewsItemCommentForm.tsx + 2 modules
var NewsItemCommentForm = __webpack_require__(33890);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemCommentList/index.tsx + 10 modules
var NewsItemCommentList = __webpack_require__(69431);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemContent/NewsItemContent.tsx + 1 modules
var NewsItemContent = __webpack_require__(30691);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemFooter/NewsItemFooter.tsx + 9 modules
var NewsItemFooter = __webpack_require__(53505);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/component/NewsItemHeader/NewsItemHeader.tsx + 4 modules
var NewsItemHeader = __webpack_require__(71387);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemModal/ScreenNewsItemModal.tsx + 2 modules
var ScreenNewsItemModal = __webpack_require__(18567);
;// CONCATENATED MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemFeed.ua.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment NewsItem_newsItemEdge on NewsItemEdge {\n    header: node {\n      ...NewsItemHeader_NewsItem\n    }\n    content: node {\n      ...NewsItemContent_NewsItem\n    }\n    footer: node {\n      ...NewsItemFooter_NewsItem\n    }\n    commentForm: node {\n      id\n      viewerCanReply\n    }\n    commentList: node {\n      id\n      viewerIsAuthor\n    }\n    cursor\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: none;\n      .desktop {\n        display: none;\n      }\n      .mobile {\n        display: block;\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  border: 1px solid #e8e8e8;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: visible;\n  .desktop {\n    display: block;\n  }\n  .mobile {\n    display: none;\n  }\n  & > .hr {\n    height: 1px;\n    background-color: #e8e8e8;\n    margin-bottom: 20px;\n  }\n  > .comment-form {\n    padding: 16px 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}















src_default()(_templateObject());
var ScreenNewsItemFeed = function(param, ref) {
    var className = param.className, data = param.data, _isExpandContent = param.isExpandContent, isExpandContent = _isExpandContent === void 0 ? false : _isExpandContent, _isExpandComment = param.isExpandComment, isExpandComment = _isExpandComment === void 0 ? false : _isExpandComment, _isShowFollowBtn = param.isShowFollowBtn, isShowFollowBtn = _isShowFollowBtn === void 0 ? false : _isShowFollowBtn;
    var _$ref, _$ref1, _$ref2, _$ref3, _$ref4, _$ref5;
    var router = (0,next_router.useRouter)();
    var _$ref6 = (0,react.useState)(isExpandComment), commentBtnState = _$ref6[0], setCommentBtnState = _$ref6[1];
    var isMobile = (0,context/* useUA */.nD)().isMobile;
    var isWebview = (0,useIsWebview/* default */.Z)();
    var target = (0,useReadNewsItemEffect/* default */.Z)((_$ref = data.header) === null || _$ref === void 0 ? void 0 : _$ref.id);
    var commentInputRef = (0,react.useRef)(null);
    var handleModal = function(modal) {
        router.push({
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                modal: modal
            })
        }, undefined, {
            scroll: false
        });
    };
    var handleCommentBtnClick = function() {
        if (isExpandComment) {
            if (isMobile) {
                var _$ref;
                (_$ref = commentInputRef.current) === null || _$ref === void 0 ? void 0 : _$ref.focus();
            }
            return;
        }
        if (isMobile) {
            var _$ref1, _$ref2, _$ref3;
            router.push((0,util/* getWebviewHref */.ys)("/channel/".concat((_$ref1 = data.header) === null || _$ref1 === void 0 ? void 0 : (_$ref2 = _$ref1.channel) === null || _$ref2 === void 0 ? void 0 : _$ref2.url, "/").concat((_$ref3 = data.header) === null || _$ref3 === void 0 ? void 0 : _$ref3.id), isWebview));
        } else {
            setCommentBtnState(!commentBtnState);
        }
    };
    var handleContentClick = function(e) {
        var _$ref, _$ref1, _$ref2;
        var targetNode = e.target;
        if (!isMobile || (0,_instanceof/* default */.Z)(targetNode, HTMLAnchorElement)) return;
        router.push((0,util/* getWebviewHref */.ys)("/channel/".concat((_$ref = data.header) === null || _$ref === void 0 ? void 0 : (_$ref1 = _$ref.channel) === null || _$ref1 === void 0 ? void 0 : _$ref1.url, "/").concat((_$ref2 = data.header) === null || _$ref2 === void 0 ? void 0 : _$ref2.id), isWebview));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledWrapper, {
        ref: ref,
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: target
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemHeader/* default */.Z, {
                data: data.header,
                showFollowBtn: isShowFollowBtn
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemContent/* default */.Z, {
                data: data.content,
                onImageClick: function() {
                    var _$ref;
                    return handleModal(((_$ref = data.header) === null || _$ref === void 0 ? void 0 : _$ref.id) || "");
                },
                onContentClick: handleContentClick,
                expendContent: isExpandContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemFooter/* default */.Z, {
                data: data.footer,
                isCommentListOpened: commentBtnState,
                onCommentBtnClick: handleCommentBtnClick
            }),
            commentBtnState === true && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentForm/* default */.Z, {
                        className: "comment-form",
                        newsItemId: ((_$ref1 = data.commentForm) === null || _$ref1 === void 0 ? void 0 : _$ref1.id) || "",
                        viewerCanReply: ((_$ref2 = data.commentForm) === null || _$ref2 === void 0 ? void 0 : _$ref2.viewerCanReply) || false,
                        ref: commentInputRef,
                        expendComment: isExpandComment
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsItemCommentList/* default */.ZP, {
                        newsItemId: ((_$ref3 = data.commentList) === null || _$ref3 === void 0 ? void 0 : _$ref3.id) || "",
                        viewerIsAuthor: ((_$ref4 = data.commentList) === null || _$ref4 === void 0 ? void 0 : _$ref4.viewerIsAuthor) || false,
                        expendComment: isExpandComment
                    })
                ]
            }),
            router.query.modal === ((_$ref5 = data.header) === null || _$ref5 === void 0 ? void 0 : _$ref5.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemModal/* default */.Z, {
                open: true,
                data: data,
                onClose: function() {
                    return handleModal("close");
                }
            })
        ]
    });
};
/* harmony default export */ var ScreenNewsItemFeed_ua = (/*#__PURE__*/(0,react.forwardRef)(ScreenNewsItemFeed));
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ScreenNewsItemFeed.ua__StyledWrapper",
    componentId: "sc-242de2a1-0"
})(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.isMobile && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});

// EXTERNAL MODULE: ./src/app.feature/channel/channel.newsItem/screen/ScreenNewsItemFeedLoading.tsx
var ScreenNewsItemFeedLoading = __webpack_require__(24744);
// EXTERNAL MODULE: ./src/app.feature/channel/channel.search/component/EmptyCard.tsx
var EmptyCard = __webpack_require__(67220);
;// CONCATENATED MODULE: ./src/app.feature/channel/component/lists/NewsList.tsx

function NewsList_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment FollowList_ChannelConnection on ChannelConnection {\n    totalCount\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n    edges {\n      ...ChannelCardList_ChannelEdge\n    }\n  }\n"
    ]);
    NewsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NewsList_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 20px;\n  .news-item-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  .end-content {\n    display: flex;\n    justify-content: center;\n    padding: 20px;\n    color: #999999;\n  }\n"
    ]);
    NewsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




// TODO   추후 ua 컴포넌트 import 수정필요



src_default()(NewsList_templateObject());
var NewsList = function(param) {
    var loading = param.loading, data = param.data, _skeletonSize = param.skeletonSize, skeletonSize = _skeletonSize === void 0 ? 3 : _skeletonSize;
    var skeletonArr = new Array(skeletonSize).fill("");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NewsList_StyledWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "news-item-card-list",
                children: [
                    loading && skeletonArr.map(function(_, idx) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ScreenNewsItemFeedLoading/* default */.Z, {}, idx);
                    }),
                    data.map(function(edge) {
                        var ref;
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ScreenNewsItemFeed_ua, {
                            data: edge,
                            isExpandContent: true,
                            isShowFollowBtn: true
                        }, "news-item-".concat((ref = edge.header) === null || ref === void 0 ? void 0 : ref.id));
                    })
                ]
            }),
            !loading && data.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyCard/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var lists_NewsList = (NewsList);
var NewsList_StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "NewsList__StyledWrapper",
    componentId: "sc-fe438545-0"
})(NewsList_templateObject1());


/***/ })

}]);